import React from 'react'
import styled from 'styled-components'
import Text from '../../atoms/Text/Text'
import Image from '../../atoms/Image/Image'

const Style = styled.div`
  flex-grow: 1;
  margin: 5px 20px;
  min-width: 250px;
  max-width: 250px;
  // padding: 16px;
  border: 1px solid #bfcbda;
  border-radius: 10px;
  float: left;
  p {
    margin-left: 0;
    margin-right: 0;
  }
  img {
    max-width: 100%;
    max-height: 250px;
    object-fit: cover;
    margin-left: 0;
    margin-right: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .text-section {
    padding: 0 16px;
  }
`

const TeamMember = ({ image, name, qualifications, position }) => {
  return (
    <Style>
      <img src={image} />
      <div className="text-section">
        <Text
          small
          fluid
          bold
          style={{
            marginTop: '16px',
            fontSize: '20px',
            color: '#162941'
          }}
        >
          {name}
        </Text>
        <Text
          fluid
          small
          style={{ color: '#162941', fontSize: '16px' }}
        >
          {position}
        </Text>
        {qualifications && (
          <>
            {qualifications.length > 0 && (
              <Text
                fluid
                style={{ fontSize: '12px', color: '#162941' }}
                italic
                color="medgray"
                small
              >
                {qualifications}
              </Text>
            )}
          </>
        )}
      </div>
    </Style>
  )
}

export default TeamMember
